// extracted by mini-css-extract-plugin
module.exports = {"header":"Contact_header__2ZIkN","contactText":"Contact_contactText__3Tqqb"};